export class mfaModel {
    client_id?: string;
    patient_id?: string;
    user_id?:string;
    mfa_code: string;
}